import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import * as React from 'react';

import { ButtonIconProps } from '../ButtonV2/ButtonIcon/ButtonIcon';
import { Button } from '../ButtonV2/ButtonV2';

interface ButtonCloseProps extends ButtonIconProps {}

export const ButtonClose = (props: ButtonCloseProps) => (
  <Button.Icon size="medium" type="secondary" {...props}>
    <IconOtherClose />
  </Button.Icon>
);
